import { api } from "../config";

type ScheduledInvoiceItem = {
    id?: number;
    scheduled_invoice?: number;
    service: number | { id: number; name: string };
    quantity: number;
    price: number;
};

export const createScheduledInvoiceItems = async (
    scheduleId: number,
    items: Array<ScheduledInvoiceItem>
) => {
    const promises = items.map((item) =>
        api({
            method: "POST",
            url: "/items/scheduled_invoices_items",
            data: {
                scheduled_invoice: scheduleId,
                service: typeof item.service === "object" ? item.service.id : item.service,
                quantity: item.quantity,
                price: item.price,
            },
        })
    );

    return await Promise.all(promises);
};

export const deleteScheduledInvoiceItems = async (scheduleId: number) => {
    const filter = { scheduled_invoice: { _eq: scheduleId } };

    const response = await api({
        method: "GET",
        url: "/items/scheduled_invoices_items",
        params: {
            filter: JSON.stringify(filter),
        },
    });

    const existingItems = response.data.data;

    if (existingItems && existingItems.length > 0) {
        const deletePromises = existingItems.map((item: any) =>
            api({
                method: "DELETE",
                url: `/items/scheduled_invoices_items/${item.id}`,
            })
        );

        await Promise.all(deletePromises);
    }
};

